import {createStyles, TableCell, TableRow, Theme, withStyles} from "@material-ui/core";

export const StyledTableCell = withStyles((theme: Theme) =>
    createStyles({
        head: {
            backgroundColor: theme.palette.common.black,
            color: theme.palette.common.white,
            padding: 20
        },
        body: {
            fontSize: 14,
            padding: 20
        },
    }),
)(TableCell)

export const StyledTableRow = withStyles((theme: Theme) =>
    createStyles({
        root: {
            '&:nth-of-type(odd)': {
                backgroundColor: theme.palette.action.hover,
            },
        },
    }),
)(TableRow)
